import { ButtonERP, OptionsMenuStorybook, TagERP } from "@finanedi.es/storybook"
import { faArrowLeft, faTrashCan } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { deleteContactoById } from "api/Contacto.service"
import { ContactoReadingDtoProps } from "api/DTOs/ContactoReadingDto"
import DeleteModal from "common/components/Modal/DeleteModal"
import notification from "common/utils/notification"
import { useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"

const EditarContactoHeader = ({
  contacto,
}: {
  contacto?: ContactoReadingDtoProps
}) => {
  const { t } = useTranslation()
  const [showDeleteModal, setShoweDleteModal] = useState(false)
  const history = useHistory()

  const deleteContacto = async () => {
    if (!contacto?.id) return
    try {
      await deleteContactoById(contacto.id)
      notification.success({
        body: `${t("contactos.eliminar.msgSuccessDelete")}`,
      })
      setShoweDleteModal(false)
      history.push(ROUTES.CONTACTOS)
    } catch (error) {
      setShoweDleteModal(false)
    }
  }

  return (
    <div className='tw-text-primary tw-bg-white tw-border-b tw-border-neutral-25 tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-gap-4 tw-py-2.5 tw-px-6 tw-mt-1'>
      <div className='tw-flex tw-flex-row tw-h-12 tw-items-center tw-flex-1 tw-gap-3'>
        <ButtonERP
          customize={{
            type: "white",
            size: "md",
          }}
          icon={<FontAwesomeIcon icon={faArrowLeft} />}
          onClick={() => history.goBack()}
        />

        <div className='tw-text-xl tw-font-medium tw-whitespace-nowrap tw-flex tw-mr-3'>
          {contacto?.razonSocial}
        </div>
        <div className='tw-flex tw-flex-row tw-flex-wrap tw-gap-1'>
          {contacto?.etiquetas?.map((etiqueta: string) => (
            <TagERP
              key={etiqueta}
              value={etiqueta}
              color='neutral'
            />
          ))}
        </div>
      </div>
      <OptionsMenuStorybook
        id='detail-Contacto'
        items={[
          {
            title: `${t("contactos.eliminar.modalHeader_one")}`,
            hasRedirect: true,
            action: () => setShoweDleteModal(!showDeleteModal),
            className: "!tw-text-danger",
            icon: faTrashCan,
          },
        ]}
        position='right'
      />
      <DeleteModal
        visible={showDeleteModal}
        onHide={() => setShoweDleteModal(!showDeleteModal)}
        size='small'
        iconType='remesas'
        buttonLabel={t("nsAssets.modalDelete.confirmLabel")}
        title={t("contactos.eliminar.modalHeader_one")}
        message={
          <Trans
            i18nKey='contactos.eliminar.modalDelete_one'
            components={[
              <span
                className='tw-font-medium tw-contents'
                key='0'
              />,
            ]}
            values={{
              contactName: contacto?.razonSocial,
            }}
          />
        }
        onConfirm={deleteContacto}
      />
    </div>
  )
}

export default EditarContactoHeader
